import React from "react";
import "./Hero.css";
import { motion } from "framer-motion";
import { FaRocket, FaArrowUp } from "react-icons/fa";

const Hero = () => {
  return (
    <section id="home" className="hero">

      {/* Background Overlay */}
      <div className="overlay"></div>

      {/* Left Scroll Text */}
      <motion.div
        className="scroll-text"
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <span>SCROLL</span>
      </motion.div>

      {/* Hero Content */}

      <div className="hero-content">

        <motion.h1
          className="line1"
          initial={{ y: 120 }}
          animate={{ y: 0 }}
          transition={{ duration: 1 }}
        >
         YOUR BUSINESS
        </motion.h1>

        <motion.div
          className="rocket"
          animate={{
            y: [0, -20, 0],
            rotate: [-5, 5, -5]
          }}
          transition={{
            repeat: Infinity,
            duration: 3
          }}
        >
          <FaRocket />
        </motion.div>

        <motion.h2
          className="line2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: .5,
            duration: 1
          }}
        >
          GROWTH
        </motion.h2>

        <motion.h2
          className="line3"
          initial={{ y: 120 }}
          animate={{ y: 0 }}
          transition={{
            delay: .4,
            duration: 1
          }}
        >
         PARTNER
        </motion.h2>

        <motion.p
          className="hero-para"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{
            delay: 1,
            duration: 1
          }}
        >
          Strategy. Ideas. Execution. Everything with IGNITE
          engrained in every fabric of what we do.
         Your Business Growth Partner
        </motion.p>

      </div>

      {/* Mouse Circle */}

      <motion.div
        className="mouse-circle"
        animate={{
          scale: [1, 1.2, 1]
        }}
        transition={{
          repeat: Infinity,
          duration: 2
        }}
      >
        <span></span>
      </motion.div>

      {/* Scroll Top Button */}

      <motion.div
        className="scroll-btn"
        whileHover={{
          scale: 1.1
        }}
      >
        <FaArrowUp />
      </motion.div>

    </section>
  );
};

export default Hero;